import { tv } from '@/ui/utils'

/**
 * Headings, in PP Right Grotesk Medium at the Style Library's mobile sizes.
 *
 * Case is a property of the level, as the brand has it: H1, H2, H6 and H7 are uppercase; H3, H4
 * and H5 are sentence case. A screen title is H2. H1 is the single hero moment a screen might
 * have, and most have none. `display` is the brand's signature numeral — a score, a date, an
 * amount — and is never used for words.
 */
export const headerStyles = tv({
	base: 'web:scroll-m-20 web:select-text text-ink font-display',
	variants: {
		variant: {
			h1: 'text-h1 uppercase',
			h2: 'text-h2 uppercase',
			h3: 'text-h3',
			h4: 'text-h4',
			h5: 'text-h5',
			h6: 'text-h6 uppercase',
			h7: 'text-h7 uppercase',
			display: 'text-display',
			'display-lg': 'text-display-lg',
			'display-md': 'text-display-md',
			'display-sm': 'text-display-sm',
		},
		tone: {
			ink: 'text-ink',
			white: 'text-white',
			ground: 'text-ground',
			mint: 'text-mint',
			muted: 'text-muted',
		},
	},
	defaultVariants: {
		variant: 'h2',
		tone: 'ink',
	},
})
